import { FaTimes, FaPaperPlane } from 'react-icons/fa';

const FeedbackModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleClose = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-purple-600 to-pink-500 text-white p-6 rounded-t-2xl flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <FaPaperPlane className="text-2xl" />
            <h2 className="text-xl font-bold">How to Reach Us</h2>
          </div>
          <button
            onClick={handleClose}
            className="p-2 hover:bg-white/20 rounded-full transition-colors"
            aria-label="Close feedback"
          >
            <FaTimes className="text-2xl" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <p className="text-sm text-gray-700">
            <span>
              If you’re enjoying the app, struggling with something, or wishing for a new feature — please tell us.
            </span>
            <br />
            <span>
              Every message helps us make this journey better for you and your child.
            </span>
            <br />
            <br />
            <span>
              Write to&nbsp;
              <a
                href="mailto:saritharkamath@gmail.com"
                className="font-medium text-purple-600 hover:text-purple-700 underline"
              >
                saritharkamath@gmail.com
              </a>
              &nbsp;or&nbsp;
              <span className="font-medium">96862 28755</span>
              &nbsp;or fill&nbsp;
              <a
                href="https://forms.gle/pXEa54usk5cstPLC7"
                target="_blank"
                rel="noopener noreferrer"
                className="text-purple-600 hover:text-purple-700 underline"
              >
                this form
              </a>
              .
            </span>
          </p>

          <div className="flex justify-end pt-2">
            <button
              type="button"
              onClick={handleClose}
              className="px-4 py-2 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-100 text-sm font-medium"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
